$.ajaxSetup({
	cache: true
});
if (templateG.indexOf("customers") >= 0)	{
  	var shopifyCommonJSPath			=	"\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/themes_support\/shopify_common-8ea6ac3faf357236a97f5de749df4da6e8436ca107bc3a4ee805cbf08bc47392.js";
  	var customerAreaJSPath			=	"\/\/cdn.shopify.com\/shopifycloud\/shopify\/assets\/themes_support\/customer_area-4beccea87758d91106a581ba89341d9b51842f6da79209258c8297239e950343.js";
  
	var shopifyCommonJS		=	getJsFileAsync( shopifyCommonJSPath );  
	var customerAreaJS		=	getJsFileAsync( customerAreaJSPath );  
}
      

/* END:: code to manage customer care popup which is part of customer-care-popup.liquid */

/* START:: code to manage product search which is part of search-form.liquid */
$(document).ready(function(jQuery) {
	$(".search-field").on("focusin focusout", function(event) {
		var $field = $(this);
		var original_val = $field.prop("defaultValue");

		if (event.type === "focusin" && $field.val() === original_val) {
			$field.val("");
		} else if (event.type === "focusout" && $field.val() === "") {
			$field.val(original_val);
		}
	});
});

/* END:: code to manage product search which is part of search-form.liquid */

/* START:: code to manage hover effect on my bag section in header.liquid */
$(document).ready(function () {
	$("#bagsection").hover(
		function(e) {
			var itemCount = $("#bagsection").attr("cart_item_count");
          	if ($("#bagpopup").length > 0)
				$("#bagpopup").css("display", "block");
          		
			if(itemCount>0)	{
				//$("#bagsection").addClass("bagsection");
				//$("#bagsection").removeClass("bagsection-none");
              	$(".bar-top").css("overflow","visible");
              	$("#myBagContainerTopRight.myBagContainer").addClass("myBagContainerActive");
                $("#greenBag").hide();
              	$("#whiteBag").show();
			} 
		},
		function (e) {
          	
			//$("#bagsection").removeClass("bagsection")
			//$("#bagsection").addClass("bagsection-none");
            if ($("#bagpopup").length > 0)
				$("#bagpopup").css("display", "none");
            $(".bar-top").css("overflow","hidden")
            $("#myBagContainerTopRight.myBagContainer").removeClass("myBagContainerActive");
          	$("#whiteBag").hide();
            $("#greenBag").show();
          /*$(".myBagContainer").addClass("myBagContainerActive");
                $("#greenBag").hide();
              	$("#whiteBag").show();*/
            
		}
    );
    $("#myBagContainerInNav").hover(
        function(e) {
            var itemCount = $("#myBagContainerInNav #bagsection").attr("cart_item_count");
            if ($("#myBagContainerInNav #bagpopup").length > 0)
                $("#myBagContainerInNav #bagpopup").css("display", "block");

            if(itemCount>0)	{
                //$(".bar-top").css("overflow","visible");
                $("#myBagContainerInNav.myBagContainer").addClass("myBagContainerActive");
                $("#myBagContainerInNav #greenBag").hide();
                $("#myBagContainerInNav #whiteBag").show();
            }
        },
        function (e) {
            if ($("#bagpopup").length > 0)
            $("#myBagContainerInNav #bagpopup").css("display", "none");
            $("#myBagContainerInNav.myBagContainer").removeClass("myBagContainerActive");
            $("#myBagContainerInNav #whiteBag").hide();
            $("#myBagContainerInNav #greenBag").show();
        }
    );
});
function closeMybag(){
  $(".bagpopupMainCont").css("display", "none");
  $(".bar-top").css("overflow","hidden")
  $(".myBagContainer").removeClass("myBagContainerActive");
  $("#whiteBag").hide();
  $("#greenBag").show();
  $("#myBagContainerInNav #whiteBag").hide();
  $("#myBagContainerInNav #greenBag").show();
}
function checkoutMybag(){
  $("#checkoutButton").trigger("click");
}
/* END:: code to manage hover effect on my bag section in header.liquid */

/* START:: code to apply effect on top nav in header.liquid */
$(document).ready(function() { 
  	superfishJS.done(function(data)	{
        $('ul.sf-menu').superfish({
          speed: 0, speedOut: 0,
          autoArrows: false
        }); 
        $("li.active").parents("li.dropdown").children("a").css("color", "#e7588e")
    });
}); 
/* END:: code to apply effect on top nav in header.liquid */


/* START:: code to manage email signup from footer fo the page in footer.liquid */
function ddSignupFooter(flag, successDiv, failureDiv, onSuccessHideDiv) {
	var emailAddr = $("#email").val();
    var width = '-50px';
    if(flag == 'h'){
        width = '-1850px';
        emailAddr = $("#emailH").val();
    }
        
    //	Event Tracking for signup | START
    eventObj				=	{};
    eventObj['category']	=	"Email Signup";
    eventObj['action']		=	"click";
    eventObj['label']		=	"footer";

    addEvent(eventObj);
    //	Event Tracking for signup | END

    var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (emailAddr !== "" && filter.test(emailAddr)) {
        $.ajax({
            url: "https://social.lollywollydoodle.com/ss/engine/intermediate.php",
            type: "GET",
           	data: { email: emailAddr, name: '', source: "wslb_signup", daily_doodler_value: "0" },
            //data: { email: emailAddr, source: "ws_signup", daily_doodler_value: "1"},
				beforeSend: function (jqXHR, settings) {
            		if (jqXHR.withCredentials !== undefined)
              			jqXHR.withCredentials = true;
        		},
            dataType: "jsonp",
            success: function (data, textStatus, jqXHR) {
                if (data === true){
                    $('#email').val('');
                    $("#"+successDiv).show();
                   //document.getElementById(successDiv).style.display = "";
                  	if (onSuccessHideDiv != null && onSuccessHideDiv !== undefined)
                    	$("#"+onSuccessHideDiv).hide();
                    //document.getElementById(onSuccessHideDiv).style.display = "none";
                }	else	{
                    //document.getElementById(failureDiv).style.display = "";
                    $("#"+failureDiv).show();
                }
            }
		});
  	}	else	{
    	//document.getElementById(failureDiv).style.display = "";
        $("#"+failureDiv).show();
  	}
}
/* END:: code to manage email signup from footer fo the page in footer.liquid */

/* START:: code to manage email signup in reg-popup.liquid */
var lb='new'; 
var className ='';
if(lb == 'new'){
	className='reg-Popup';
} 

function are_cookies_enabled()
{
	var cookieEnabled = (navigator.cookieEnabled) ? true : false;

	if (typeof navigator.cookieEnabled == "undefined" && !cookieEnabled)
	{ 
		document.cookie="testcookie";
		cookieEnabled = (document.cookie.indexOf("testcookie") != -1) ? true : false;
	}
	return (cookieEnabled);
}

faceboxJS.done(function(data)	{
  webtoolkitCookiesJS.done(function(data)	{
    $(function() {
        $(document).bind('close.facebox', function() {
            closeCoupnPopup(1);
        });

        if (!Boolean(cookieHandler.getCookie("seenCouponPopup")) && cookieHandler.getCookie("seenCouponPopup")!= 'email_provided' && are_cookies_enabled() == true && page_handle !== "help-center") {
            $.facebox.settings.closeImage = "//cdn.shopify.com/s/files/1/0178/6743/t/244/assets/reg-popup-close.png?v=69469973111052816931508102673";
            $.facebox.settings.opacity = '0.8';

            if(mediaInsta){
                //popupInterval = setTimeout(function(){jQuery.facebox({ div: '#coupon-popup'},className)},1);
                setTimeout(function(){jQuery.facebox({ div: '#coupon-popup'},className)},1000);
            }	else	{ 
                //jQuery.facebox({ div: '#coupon-popup'},className);
                setTimeout(function(){jQuery.facebox({ div: '#coupon-popup'},className)},1000);
            } 

            //$("#facebox").css({left:"20%"});
            $('.popup_fb').css({width:"694px"});
            if(lb!='new'){
                jQuery('img.close_image').css('display','none'); 
            }  
            //$('#facebox_overlay').unbind("click");  
        }
    });
  });
});

function closeCoupnPopup(flag){
  if(flag != 1){
    cookieHandler.setCookie("seenCouponPopup", "true", 315360000);
    $(document).trigger('close.facebox');
  }else{
    if(!Boolean(cookieHandler.getCookie("seenCouponPopup"))) { 
      cookieHandler.setCookie("seenCouponPopup", "true");
    }  
  }  
}  

function validateCouponPopup(){
  //var fname = $("#reg-fname").val();
  //var emailAddr = $("#reg-email").val();
  var fname='';
  $('#facebox').find('#cpErrMsg').html('');  
  var emailAddr=$('#facebox').find('#email').val();
  var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

  //	Event Tracking for signup | START
  eventObj				=	{};
  eventObj['category']	=	"Email Signup";
  eventObj['action']		=	"click";
  eventObj['label']		=	"popup";

  addEvent(eventObj);
  //	Event Tracking for signup | END

  if (emailAddr !== "" && filter.test(emailAddr)) {
    $("#reg-submit-loading").css("display", "");
    $("#reg-submit").css("visibility", "hidden");

    $.ajax({
      url: "https://social.lollywollydoodle.com/ss/engine/intermediate.php",
      type: "GET",
      beforeSend: function (jqXHR, settings) {
      if (jqXHR.withCredentials !== undefined)
      jqXHR.withCredentials = true;
    },
           data: { email: emailAddr, name: fname, source: "wslb_signup", daily_doodler_value: "0", 
           landing_site:document.documentURI, referrer:document.referrer},
           dataType: "jsonp",
           success: function (data, textStatus, jqXHR) {
      //$("#reg-submit-loading").css("display", "none");
      //$("#reg-submit").css("visibility", "")

      if (data === true) {
/*
        mixpanel.identify(emailAddr);
        mixpanel.people.set({
          "$email": emailAddr,
          "$first_name": fname
        });
*/
        cookieHandler.setCookie("seenCouponPopup", "email_provided", 315360000);
        cookieHandler.setCookie("gotreg", "fname|email", 315360000);
        $.facebox.settings.closeImage = "//cdn.shopify.com/s/files/1/0178/6743/t/244/assets/reg-popup-close.png?v=69469973111052816931508102673";
        jQuery.facebox({ div: '#coupon-popup-thanks'},className);
        $("#facebox").css({left:"25%"}); 
        //setInterval(function(){$(document).trigger('close.facebox')},2000);
      }	else	{
        alert("WHOOPS! Please try again");
      }
    }
  });
}	else	{
  $('#facebox').find('#cpErrMsg').html('Please enter valid email address.');  
}
}
/* END:: code to manage email signup in reg-popup.liquid */

/* START:: code to apply class on product images was pulled from theme.liquid */
$(document).ready(function()	{
    $('#product-list .photo').hover(function()	{
        $(this).addClass('photo-hover');
    }, function()	{
        $(this).removeClass('photo-hover');
    });
});
/* END:: code to apply class on product images was pulled from theme.liquid */

/* START:: code to show timer if showTimer is enabled | pulled from theme.liquid */

    countdownJS.done(function(data)	{
        var endChrisTimerDate = '2015/10/22 00:00:00';
        $("#christmasTimer").countdown(endChrisTimerDate, function(event) {
            $('#lexImageBlock').hide();
            $('#timerShell').show();
            $(this).html(event.strftime('%D')+' day : '+event.strftime('%H')+'hr : '+event.strftime('%M')+'min : '+event.strftime('%S')+'sec');
            if(event.type == 'finish')	{
                $('#lexImageBlock').show();
                $('#timerShell').hide();
            }
        });
    });

/* END:: code to show timer if showTimer is enabled | pulled from theme.liquid */

/* START:: code to triggeremail | pulled from theme.liquid */
var c=c||[];c.load=function(a){function d(a){return function(){c.push([a].concat(Array.prototype.slice.call(arguments,0)))}}var b=document.createElement("script");b.type="text/javascript";b.async=!0;b.src=("https:"===document.location.protocol?"https://":"http://")+"triggeredmail.appspot.com/triggermail.js/"+a+".js";a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(b,a);b=["identify","track"];for(a=0;a<b.length;a++)c[b[a]]=d(b[a])};c.load("lwd");window.triggermail=c;
/* END:: code to triggeremail | pulled from theme.liquid */

/* START:: code for fix firfox for mac | pulled from theme.liquid */
if (navigator.platform.indexOf("Mac") != -1 && navigator.userAgent.indexOf("Gecko") != -1)
{
    document.write("<style type='text/css'>");
    document.write("<\/style>");
}
/* END:: code for fix firfox for mac | pulled from theme.liquid */


$(document).ready(function() {
    webtoolkitCookiesJS.done(function(done)	{
        var m = window.location.search.match(/clickid=([^&]+)/);
        if (m !== null) {
            cookieHandler.setCookie("gan_clickid", m[1], 2592000);
        }
/*
        mixpanel.track_links(".nav_link", "nav_click", function (e) {
            return { tab: $(e).data("tab") };
        });
*/
    });
});

/* START:: Size Chart popup | size-chart.liquid */
$(document).ready(function() {
  	faceboxJS.done(function(data){
        if($("#collection_size_chart").length){
          $('#collection_size_chart').facebox();
          $('#collection_size_chart').click(function (){
            jQuery('img.close_image').css('display','none'); 
            //$("#facebox").css({left:"20%"});
            $('#facebox .content').css({width:"814px",padding:"0",background:"#FFF","text-align":"left"});
            setSCPopupPosition();
          });
        }
        $('#size_chart').facebox();
        $('#size_chart').click(function (){
          jQuery('img.close_image').css('display','none'); 
          //$("#facebox").css({left:"20%"});
          $('#facebox .content').css({width:"814px",padding:"0",background:"#FFF","text-align":"left"});
          setSCPopupPosition();
        });
    });
});

function setSCPopupPosition(){
  var scLeft	=	$(window).width() / 2 - ($('#facebox .popup_fb').width() / 2);
  $('#facebox').css('left', scLeft+'px');
} 

function closefacebox(){
  $(document).trigger('close.facebox');
} 

function showContent(flagContent){
  if(flagContent == 'B'){
    $('#facebox').find('#bayCon').show();
    $('#facebox').find('#ladyCon').hide();
    $('#facebox').find('#girlCon').hide();
    $('#facebox').find('#boysCon').hide();
    $('#facebox').find('#defLeftShell').show();
    $('#facebox').find('#ladiesleftShell').hide();
    $('#facebox').find('#ladyM').removeClass('activeSizeMenu');
    $('#facebox').find('#girlM').removeClass('activeSizeMenu');
    $('#facebox').find('#babyM').addClass('activeSizeMenu');
    $('#facebox').find('#leggingM').removeClass('activeSizeMenu');
  } 
  if(flagContent == 'G'){
    $('#facebox').find('#girlCon').show();
    $('#facebox').find('#ladyCon').hide();
    $('#facebox').find('#bayCon').hide();
    $('#facebox').find('#boysCon').hide();
    $('#facebox').find('#defLeftShell').show();
    $('#facebox').find('#ladiesleftShell').hide();
    $('#facebox').find('#ladyM').removeClass('activeSizeMenu');
    $('#facebox').find('#babyM').removeClass('activeSizeMenu');
    $('#facebox').find('#girlM').addClass('activeSizeMenu');
    $('#facebox').find('#leggingM').removeClass('activeSizeMenu');
  }     
  if(flagContent == 'L'){
    $('#facebox').find('#ladyCon').show();
    $('#facebox').find('#girlCon').hide();
    $('#facebox').find('#bayCon').hide();
    $('#facebox').find('#boysCon').hide();
    $('#facebox').find('#defLeftShell').hide();
    $('#facebox').find('#ladiesleftShell').show();
    $('#facebox').find('#babyM').removeClass('activeSizeMenu');
    $('#facebox').find('#girlM').removeClass('activeSizeMenu');
    $('#facebox').find('#ladyM').addClass('activeSizeMenu');
    $('#facebox').find('#leggingM').removeClass('activeSizeMenu');
  }
  if(flagContent == 'Bo'){
    $('#facebox').find('#ladyCon').hide();
    $('#facebox').find('#girlCon').hide();
    $('#facebox').find('#bayCon').hide();
    $('#facebox').find('#boysCon').show();
    $('#facebox').find('#defLeftShell').show();
    $('#facebox').find('#ladiesleftShell').hide();
    $('#facebox').find('#babyM').removeClass('activeSizeMenu');
    $('#facebox').find('#girlM').removeClass('activeSizeMenu');
    $('#facebox').find('#ladyM').removeClass('activeSizeMenu');
    $('#facebox').find('#leggingM').addClass('activeSizeMenu');
  }     
}  
/* END:: Size Chart popup | size-chart.liquid */


var mediaInsta= false;  


/* START:: Arrow on navigation on hover effect */
/*function navigationUpArrow(index)	{
    $("#show-arrow-nav" + index).hover(
      function(e) {
        $(".menu_hoverImgClass").css("display", "none");	
        $("#menu_hoverImg" + index).css("display", "");
        $("#menu_hoverBlankImg" + index).css("display", "");  
      },
      function (e) {
        $(".menu_hoverImgClass").css("display", "none");
      }
    );
}*/
/* END:: Arrow on navigation on hover effect */

/* START:: registering customer variable */
if (customer !== null)	{
  var user_id = customer.id;
$.when(webtoolkitCrc32JS,webtoolkitMd5JS).done(function(){
    var ut1 = Math.abs(crc32( customer.email )) + "_" + MD5( customer.email );
})
}	else	{
  var user_id = "";
  var ut1 = "";
}

if (customer !== null && customer.accepts_marketing)	{
  var customer = {
    "name": 	customer.name,
    "email": 	customer.email
  };
}

$(document).ready(function() {
    var top_navigation = 135;
    $(window).scroll(function() {
        if( $(window).scrollTop() > top_navigation ) {
            $("#top_navigation").addClass("fixed_top_navigation");
            $("#top_navigation").addClass("top_nav_shadow");
            $("#myBagContainerInNav").show();
            $("#bagsection #bagpopup").css("display", "none");
            $("#top_navigation_spacer").show();
        } else {
           $("#top_navigation").removeClass("fixed_top_navigation");
           $("#myBagContainerInNav").hide();
           $("#top_navigation").removeClass("top_nav_shadow");
           $("#top_navigation_spacer").hide();
        }
    })
    if( $(window).scrollTop() > top_navigation ) {
        $("#top_navigation").addClass("fixed_top_navigation");
        $("#myBagContainerInNav").show();
        $("#top_navigation").addClass("top_nav_shadow");
        $("#top_navigation_spacer").show();
    }
})